<template>
  <el-header>
    <div class="header-container">
      <div class="hc-top">
        <div class="hct-wrapper">
          <div class="hctw-left">{{ websiteConfig.headerTitle || '快测检测认证网 - 全球检测认证业务综合服务平台！' }}</div>
          <div class="hctw-right">
            <span class="type">全国统一服务热线：</span>
            <el-image :src="require('@/assets/layout/phone.png')"></el-image>
            <a :href="'tel:'+websiteConfig.contactPhone" class="value">{{ websiteConfig.contactPhone }}</a>
          </div>
        </div>
      </div>
      <logo-area-search/>
      <classify-nav/>
      <current-location/>
    </div>
  </el-header>
</template>

<script>
import LogoAreaSearch from "./LogoAreaSearch.vue";
import ClassifyNav from "./ClassifyNav.vue";
import CurrentLocation from "./CurrentLocation.vue";
import {getWebsiteConfig} from "@/utils/website-config";

export default {
  components: {
    LogoAreaSearch,
    ClassifyNav,
    CurrentLocation
  },
  name: "CHeader",
  computed: {
    // 网站配置
    websiteConfig() {
      return getWebsiteConfig()
    }
  }
}
</script>

<style scoped lang="scss">
.el-header {
  width: 100%;
  padding: 0;
  height: auto !important;
  background-color: #ffffff;

  .header-container {
    width: 100%;
    display: flex;
    flex-direction: column;

    .hc-top {
      width: 100%;
      height: 50px;
      background-color: #FFFFFF;
      display: flex;
      flex-direction: row;
      justify-content: center;

      .hct-wrapper {
        width: 1200px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: bold;

        .hctw-right {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 26px;

          .type {
            font-weight: normal;
            color: #333333;
            font-weight: bold;
          }
          .value {
            margin-left: 4px;
            text-decoration: none;
            color: #000000;
          }
        }
      }
    }
  }
}
</style>